// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"81a70141","1353":"eb94911d","1898":"0ad1e3b7","1900":"eb94911d","2312":"f6acde3d","2875":"eb94911d","3164":"eb94911d","3192":"4f14f3b8","7187":"8a9d869d","7497":"81a70141","8120":"eb94911d","9442":"0c1df372","9994":"95d2c91a"}[chunkId] + ".chunk.css";
};